var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaistcoat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.966,
    height: 56,
    viewBox: "0 0 56.966 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.574 4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.8,25.15A25.991,25.991,0,0,0,30.22,3.125l6.175,2V21.074a4.93,4.93,0,0,0,1.517,3.539l2.646,2.558L38.546,43.2,28.156,49.169,17.8,43.2Z",
    transform: "translate(-1.252 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.39,20.673A25.641,25.641,0,0,1,16.413,3.125l-6.175,2V21.074a4.931,4.931,0,0,1-1.517,3.539L6.075,27.17,8.13,43.2l10.347,5.969,4.41-2.558",
    transform: "translate(-6.075 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.4,3.125a22.678,22.678,0,0,0,18.63,0",
    transform: "translate(-3.062 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.017,21.392a1.059,1.059,0,1,0-1.058,1.023,1.041,1.041,0,0,0,1.058-1.023Z",
    transform: "translate(0.047 3.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.017,25.792a1.059,1.059,0,1,0-1.058,1.023,1.041,1.041,0,0,0,1.058-1.023Z",
    transform: "translate(0.047 4.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.017,30.192a1.059,1.059,0,1,0-1.058,1.023,1.041,1.041,0,0,0,1.058-1.023Z",
    transform: "translate(0.047 6.362)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.251,
    transform: "translate(31.04 32.026)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.251,
    transform: "translate(1.014 32.026)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 56.966,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaistcoat);
export default __webpack_public_path__ + "static/media/Waistcoat.d2164a68da4d91bfb38d4e54cc02bd25.svg";
export { ForwardRef as ReactComponent };